import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const CreateBookingButtons = ({ onCancel, bookButtonLabel, cancelButtonLabel, onBook, photographers }) => {
    let theme = useTheme();
    let isSmallerScreen = useMediaQuery(theme.breakpoints.down('sm'));

    if (isSmallerScreen) {
        return (
            <Grid
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    margin: 'auto auto 24px auto',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                    paddingBottom: photographers.length < 1 ? '' : '30px'
                }}
            >
                {photographers.length < 1 ? null : (
                    <Button
                        sx={{ fontSize: '15px', width: '111px', height: '55px' }}
                        variant={'contained'}
                        onClick={onBook}
                        aria-label='book-btn'
                    >
                        {bookButtonLabel}
                    </Button>
                )}
                <Button
                    variant={'text'}
                    sx={{
                        fontSize: '15px',
                        width: '111px',
                        height: '55px',
                        padding: '6px 30px',
                        fontWeight: 500,
                        lineHeight: '26px'
                    }}
                    onClick={onCancel}
                >
                    {cancelButtonLabel}
                </Button>
            </Grid>
        );
    }
    return (
        <Grid
            sx={{
                margin: photographers.length < 1 ? 'auto' : '',
            }}
        >
            <Button
                variant={'text'}
                sx={{
                    fontSize: '15px',
                    width: '85px',
                    height: '42px',
                    padding: '6px 30px',
                    fontWeight: 500,
                    lineHeight: '26px'
                }}
                onClick={onCancel}
            >
                {cancelButtonLabel}
            </Button>
            {photographers.length < 1 ? null : (
                <Button
                    sx={{ fontSize: '15px', width: '85px', height: '42px', marginLeft: '8px' }}
                    variant={'contained'}
                    onClick={onBook}
                    aria-label='book-btn'
                >
                    {bookButtonLabel}
                </Button>
            )}
        </Grid>
    );
};

export default CreateBookingButtons;
